import Modal from "../ui/Modal";
import LeadScoringForm from "../leads/LeadScoringForm";
import ChatBoxConfigurationForm from "../ui/ChatBoxConfigurationForm";
import { DEFAULT_CHATBOX, initialLeadData } from "../../data/intialData";

import {useAgentStore} from "../../store/agentStore";

import { Settings, MessageSquare, Sliders } from "lucide-react";


export default function AgentSettingsModals({
  activeForm,
  showSettingsModal,
  setShowSettingsModal,
  closeModal,
  handleSettingsOption,
  activeTab,
  setActiveTab,
  agentDetails,
  saveScoring,
  handleManageWidgetSettings,
  isLoading,
}) {

  const {selectedAgent} = useAgentStore();

  const chatboxSettings = selectedAgent?.settings || agentDetails?.settings || DEFAULT_CHATBOX;
  const scoringConfig = selectedAgent?.scoring_config || agentDetails?.scoring_config || initialLeadData;

  const settingsOptions = [
    {
      key: "leadscore",
      label: "Lead Settings",
      description: "Update scoring weights for lead qualification.",
      icon: Sliders,
    },
    {
      key: "chatbox",
      label: "Widget Settings",
      description: "Configure greeting, colors, position, and logo.",
      icon: MessageSquare,
    },
    {
      key: "both",
      label: "Both",
      description: "Manage lead and widget configuration together.",
      icon: Settings,
    },
  ];

  const handleModalClose = () => {
    if (isLoading) return;
    closeModal();
  };

  return (
    <>
      {/* Selection Modal */}
      <Modal
        isOpen={showSettingsModal}
        onClose={() => setShowSettingsModal(false)}
        title="Select Configuration"
        className="settings-selection-modal"
      >
     <div className="settings-option-list">
  {settingsOptions.map((option) => {
    const Icon = option.icon;

    return (
      <button
        key={option.key}
        type="button"
        className="settings-option-btn"
        onClick={() => handleSettingsOption(option.key)}
        disabled={isLoading}
      >
        <div className="d-flex align-center gap-2">
          <Icon size={18} className="text-primary" />

          <div className="d-flex flex-column text-left">
            <span className="settings-option-title">
              {option.label}
            </span>
            <span className="settings-option-subtitle">
              {option.description}
            </span>
          </div>
        </div>
      </button>
    );
  })}
</div>
      </Modal>

      {/* Lead */}
      <Modal
        isOpen={activeForm === "leadscore"}
        onClose={handleModalClose}
        title="Edit Lead Scores"
        className="lead-scoring-modal-content"
      >
        <LeadScoringForm
          className="lead-scoring-modal-content"
          initialValues={scoringConfig}
          onSubmit={saveScoring}
          isLoading={isLoading}
        />
      </Modal>

      {/* Chatbox */}
      <Modal
        isOpen={activeForm === "chatbox"}
        onClose={handleModalClose}
        title="Edit Chatbox"
      >
        <ChatBoxConfigurationForm
          chatboxSettings={chatboxSettings}
          onSubmit={handleManageWidgetSettings}
          isLoading={isLoading}
        />
      </Modal>

      {/* BOTH */}
      <Modal
        isOpen={activeForm === "both"}
        onClose={handleModalClose}
        title="Manage Both"
        className="lead-scoring-modal-content"
      >
        <div className="settings-tab-toggle">
          <button
            type="button"
            className={`settings-tab-btn ${activeTab === "leadscore" ? "active" : ""}`}
            onClick={() => setActiveTab("leadscore")}
            disabled={isLoading}
          >
            Lead
          </button>
          <button
            type="button"
            className={`settings-tab-btn ${activeTab === "chatbox" ? "active" : ""}`}
            onClick={() => setActiveTab("chatbox")}
            disabled={isLoading}
          >
            Chat
          </button>
        </div>

        {activeTab === "leadscore" && (
          <LeadScoringForm
            className="lead-scoring-modal-content"
            initialValues={scoringConfig}
            onSubmit={saveScoring}
            isLoading={isLoading}
          />
        )}

        {activeTab === "chatbox" && (
          <ChatBoxConfigurationForm
            chatboxSettings={chatboxSettings}
            onSubmit={handleManageWidgetSettings}
            isLoading={isLoading}
          />
        )}
      </Modal>
    </>
  );
}